<template>
  <div class="nav">
    <div class="with-divisor">
      <span class="institutions">
        <a href="http://c4ai.inova.usp.br/" target="_blank">
          <img class="institution" src="../assets/c4ai.png" />
        </a>
        <a href="http://www.nilc.icmc.usp.br/" target="_blank">
          <img class="institution middle" src="../assets/nilc.jpg" />
        </a>
        <a href="http://www.saocarlos.usp.br/" target="_blank">
          <img class="institution" src="../assets/usp.png" />
        </a>
      </span>
      <span
        >v1.0.0 – this webpage was made with 💙 by
        <a href="https://www.linkedin.com/in/lucasgmm/" target="_blank"
          >Lucas Miranda</a
        ></span
      >
      <br />
      <br />
      <span>Last updated: June-12-2023</span>
    </div>
  </div>
</template>

<script></script>

<style scoped>
.institutions {
  display: block;
}

.middle {
  margin-left: 40px;
  margin-right: 40px;
}

.institution {
  width: 100px;
  margin-bottom: 30px;
}

.license-line {
  display: block;
}

.cc-logo {
  vertical-align: bottom;
  width: 1.1rem;
}

.nav {
  text-align: center;
  font-family: "Roboto", sans-serif;
  color: #495057;
  font-size: 14px;
}

.with-divisor {
  padding: 30px 0 30px 0;
  margin: 0px 40px;
  border-top: 1px solid;
  border-color: #e4e5e8;
}
</style>
